import React from 'react'
import { IonListHeader, IonItem, IonInput } from '@ionic/react'
import { FormTitle } from '../maps/StyledContainers'

const EmergencyContactSection = ({ emergency, setEmergency }) => (
  <>
    <IonListHeader>
      <FormTitle>
        <h3 style={{ fontSize: '1rem' }}>Emergency Contact Details</h3>
      </FormTitle>
    </IonListHeader>
    <IonItem>
      <IonInput
        onIonChange={(e) => setEmergency({ ...emergency, [e.target.name]: e.detail.value })}
        value={emergency.emergencyPhone}
        name='emergencyPhone'
        id='journey-emergency-phone1'
        type='text'
        placeholder='Emergency Phone No. 1'
      />
    </IonItem>
    <IonItem>
      <IonInput
        onIonChange={(e) => setEmergency({ ...emergency, [e.target.name]: e.detail.value })}
        value={emergency.altEmergencyPhone}
        name='altEmergencyPhone'
        id='journey-emergency-phone2'
        type='text'
        placeholder='Emergency Phone No. 2'
      />
    </IonItem>
  </>
)

export default EmergencyContactSection
